export default __webpack_public_path__ + "static/media/since1999_tc.c54c5766.png";